import Input from '../controls/Input';
import React, { useEffect, useState } from 'react'
import MasterPage from '../app/MasterPage';
import Card from '../controls/Card';
import { MdErrorOutline, MdMedicalInformation, MdOutlineLocalPhone } from "react-icons/md";
import { PiPassword, PiPhone } from "react-icons/pi";
import { BsFillPersonLinesFill, BsGenderAmbiguous } from "react-icons/bs";
import { RiLockPasswordFill } from 'react-icons/ri';
import { FaAddressCard, FaBriefcaseMedical, FaLocationDot, FaMapLocationDot, FaUserDoctor } from "react-icons/fa6";
import { FaUserGraduate } from "react-icons/fa";
import { CreateNewUser, MobileOtpGenerate, MobileOtpVerify } from '../../configurations/crud/mobileVerificationCrud';
import { useToast } from '../controls/Toast/ToastService';
import { IoCheckmarkDoneCircleOutline } from 'react-icons/io5';
import { useFormik } from 'formik';
import * as yup from 'yup'
import LodingButton from '../controls/LodingButton';
import { GetAll } from '../../configurations/crud/stateCrud';
import * as cityCrud from '../../configurations/crud/cityCrud'
import * as getSpecialisation from '../../configurations/crud/doctorsSpecialisation'
import { GetEGender } from '../../configurations/enums/EGender';
import UserRegisterCompleted from './UserRegisterCompleted';
import { MyCaptcha, validateCaptcha } from '../base/MyCaptcha';
import { text } from '@fortawesome/fontawesome-svg-core';
import { useNavigate } from 'react-router-dom';
import Select from '../controls/Select';
import useGlobalLoader from '../../configurations/useGlobalLoader';

const schema = yup.object().shape({
    fullName: yup.string().required("Full Name is required"),
    password: yup.string().required("Password is required.").matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
        "Must be 8 Chars, One Upper, Lower, Number & Special Char"
    ),
    specialisationId: yup.string().required("specialisationId is required"),
    degree: yup.string().required("Degree is required"),
    experiance: yup.string().required("Experience is required"),
    address: yup.string().required("Address is required"),
    cityId: yup.string().required("City is required"),
    stateId: yup.string().required("State is required"),
})

export default function CreateAccount() {
    const { start, end } = useGlobalLoader()
    const [level, setLevel] = useState(1)
    const [lodingCrud, setLodingCrud] = useState(false);
    const [mobileNumber, setMobileNumber] = useState('');
    const [otp, setOtp] = useState('');
    const [token, setToken] = useState('');
    const toast = useToast()
    const [lodingStateCrud, setLodingStateCrud] = useState(false)
    const [stateData, setStateData] = useState([])
    const [lodingCityCrud, setLodingCityCrud] = useState(false)
    const [cityData, setCityData] = useState([]);
    const [specialisationData, setSpecialisationData] = useState([])
    const [loding, setLoding] = useState(false)
    const [ctext, setCtext] = useState("");
    const [errorCount, setErrorCount] = useState(0);
    const navigate = useNavigate()

    const { values, handleBlur, handleChange, handleSubmit, errors, touched, isValid, setValues } = useFormik({
        initialValues: {
            fullName: "",
            password: "",
            specialisationId: "",
            degree: "",
            securityPIN: "0000",
            experiance: "",
            gender: "0",
            address: "",
            cityId: "",
            stateId: ""
        },
        validationSchema: schema,
        onSubmit(val) {
            CreateAccount(val)
        }
    })

    const SendOtpMobile = () => {
        if (mobileNumber) {
            let flag = true;
            flag = validateCaptcha(ctext)
            if (ctext && flag) {
                setLodingCrud(true)
                start()
                MobileOtpGenerate(mobileNumber).then(res => {
                    let mdata = res.data
                    if (mdata.result.succeeded) {
                        setLevel(2);
                        toast.open("Otp Send Successfully.", <IoCheckmarkDoneCircleOutline />, "success")
                    } else {
                        toast.open(mdata.result.message, <MdErrorOutline />, "danger")
                    }
                    setLodingCrud(false)
                    end()
                }).catch(errors => {
                    setLodingCrud(false)
                    end()
                    toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
                })
            }
            else {
                if (errorCount < 2) {
                    setErrorCount(pre => pre + 1)
                    toast.open("Invalid Captcha", <MdErrorOutline />, "danger")
                }
                else {
                    navigate("/")
                    toast.open("Too many try.", <MdErrorOutline />, "danger")
                }
            }
        }
        else {
            toast.open("Please enter mobile number", <MdErrorOutline />, "danger")
        }
    }

    const VerifyOtpMobile = () => {
        if (otp) {
            setLodingCrud(true)
            start()
            MobileOtpVerify(mobileNumber, otp).then(res => {
                let mdata = res.data
                if (mdata.succeeded) {
                    setLevel(3);
                    setToken(mdata.message)
                    toast.open("Otp Verifed Successfully.", <IoCheckmarkDoneCircleOutline />, "success")
                } else {
                    toast.open("Invalid OTP", <MdErrorOutline />, "danger")
                }
                setLodingCrud(false)
                end()
            }).catch(errors => {
                setLodingCrud(false)
                end()
                toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
            })
        }
        else {
            toast.open("Please enter OTP", <MdErrorOutline />, "danger")
        }
    }

    const CreateAccount = (param) => {
        setLodingCrud(true)
        start()
        let mparam = {
            fullName: param.fullName,
            mobileNo: mobileNumber,
            password: param.password,
            token: token,
            specialisationId: param.specialisationId,
            degree: param.degree,
            securityPIN: param.securityPIN,
            experiance: param.experiance,
            gender: param.gender,
            address: param.address,
            cityId: param.cityId,
            stateId: param.stateId
        }
        CreateNewUser(mparam).then(res => {
            let mdata = res.data
            if (mdata.succeeded) {
                setValues({
                    fullName: "",
                    mobileNo: "",
                    password: "",
                    token: "",
                    specialisationId: "",
                    degree: "",
                    securityPIN: "0000",
                    experiance: "",
                    gender: "0",
                    address: "",
                    cityId: "",
                    stateId: ""
                })
                setLevel(4);
                toast.open("Account Created Successfully.", <IoCheckmarkDoneCircleOutline />, "success")
            } else {
                toast.open(mdata.message, <MdErrorOutline />, "danger")

            }
            setLodingCrud(false)
            end()
        }).catch(errors => {
            setLodingCrud(false)
            end()
            toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
        })
    }

    useEffect(() => {
        GetStates()
        GetSpecialisations()
    }, [])
    const GetStates = () => {
        setLodingStateCrud(true)
        start()
        GetAll().then(res => {
            let mdata = res.data
            if (mdata.result.succeeded) {
                setStateData(mdata.data)
            } else {
                setStateData([])
                toast.open(mdata.result.message, <MdErrorOutline />, "danger")
            }
            setLodingStateCrud(false)
            end()
        }).catch(errors => {
            setStateData([])
            setLodingStateCrud(false)
            end()
            toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
        })
    }
    useEffect(() => {
        if (stateData.length > 0 && values.stateId != "") {
            GetCities()
        }
        setValues({ ...values, cityId: "" })
    }, [values.stateId])

    const GetCities = () => {
        setLodingCityCrud(true)
        start()
        cityCrud.GetAll(values.stateId).then(res => {
            let mdata = res.data
            if (mdata.result.succeeded) {
                setCityData(mdata.data)
            } else {
                setCityData([])
                toast.open(mdata.result.message, <MdErrorOutline />, "danger")
            }
            setLodingCityCrud(false)
            end()
        }).catch(errors => {
            setCityData([])
            setLodingCityCrud(false)
            end()
            toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
        })
    }

    const GetSpecialisations = () => {
        setLoding(true)
        start()
        getSpecialisation.GetAll().then(res => {
            let mdata = res.data
            if (mdata.result.succeeded) {
                setSpecialisationData(mdata.data)
            } else {
                setSpecialisationData([])
                toast.open(mdata.result.message, <MdErrorOutline />, "danger")
            }
            setLoding(false)
            end()
        }).catch(errors => {
            setSpecialisationData([])
            setLoding(false)
            end()
            toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
        })
    }
    const onMobileChange = (event) => {
        const value = event.target.value;
        // Allow only numeric characters (0-9)
        const numericValue = value.replace(/[^0-9]/g, '');
        setMobileNumber(numericValue);
    };
    return (
        <MasterPage>

            {level === 1 &&
                <div className="flex flex-col min-h-full justify-center px-6 py-12 lg:px-8 bg-slate-100">
                    <div className="mx-auto w-full max-w-sm p-6 flex flex-col min-h-full justify-center">

                        <Card title={"Create An Account"} isBorder={true} isBack={true}>

                            <div className="my-5 sm:mx-auto sm:w-full sm:max-w-sm ">
                                <div className="space-y-6">

                                    <div>
                                        <label for="mobileNumber" className="block text-sm font-medium leading-6 text-gray-900">
                                            Mobile no.
                                        </label>
                                        <div className="mt-2">
                                            <Input placeholder="Enter mobile no."
                                                id="mobileNumber"
                                                maxLength={10}
                                                value={mobileNumber}
                                                onChange={onMobileChange}
                                                Icon={<MdOutlineLocalPhone className="text-blue-600 text-lg" />} />

                                        </div>
                                        <div className="mt-2">
                                            <label class="block clearfix" style={{ textAlign: "right" }}>
                                                <MyCaptcha setResult={setCtext} />
                                            </label>
                                        </div>
                                    </div>
                                    <div>
                                        {lodingCrud ?
                                            <LodingButton text={"Sending otp.."} />
                                            :
                                            <button className="btn-blue" onClick={SendOtpMobile}>
                                                Get OTP
                                            </button>}
                                    </div>
                                </div>
                            </div>
                        </Card>
                    </div>
                </div>
            }
            {level === 2 &&
                <div className="flex flex-col min-h-full justify-center px-6 py-12 lg:px-8 bg-slate-100">
                    <div className="mx-auto w-full max-w-sm p-6 flex flex-col min-h-full justify-center">
                        <Card isBorder={true} title={"Create An Account"}>
                            <div className="my-5 sm:mx-auto sm:w-full sm:max-w-sm ">
                                <div className="space-y-6">
                                    <div>
                                        <label className="block text-sm font-medium leading-6 text-gray-900">Mobile No.</label>
                                        <h1 className="text-3xl flex justify-center items-center gap-1 text-green-600">
                                            <PiPhone /><span>{mobileNumber}</span><button onClick={() => setLevel(1)} className='text-blue-700 cursor-pointer hover:text-blue-500 text-sm'>Edit</button>
                                        </h1>
                                    </div>
                                    <div>
                                        <label For="otp" className="block text-sm font-medium leading-6 text-gray-900">
                                            OTP
                                        </label>
                                        <div className="mt-2">
                                            <Input placeholder="Enter OTP"
                                                id="otp"
                                                value={otp}
                                                onChange={(e) => setOtp(e.target.value)}
                                                Icon={<PiPassword className="text-green-600 text-lg" />} />
                                        </div>

                                    </div>
                                    <div>
                                        {lodingCrud ?
                                            <LodingButton text={"Verifing otp.."} />
                                            :
                                            <button className="btn-blue" onClick={VerifyOtpMobile}>
                                                Verify OTP
                                            </button>
                                        }
                                    </div>
                                </div>
                            </div>
                        </Card>
                    </div>
                </div>
            }
            {level === 3 &&
                <div className='w-full lg:flex lg:flex-col pb-6 lg:items-center' >
                    <div className='lg:w-8/12'>
                        <Card title={"Create An Account"} isBack={true} isBorder={true}>
                            <form onSubmit={handleSubmit}>
                                <div class="p-6 space-y-6">
                                    <div class="grid grid-cols gap-6">
                                        <div class="col-span-12">
                                            <h1 className="text-3xl flex justify-center items-center gap-1 text-green-600">
                                                <PiPhone /><span>{mobileNumber}</span><button onClick={() => setLevel(1)} className='text-blue-700 cursor-pointer hover:text-blue-500 text-sm'>Edit</button>
                                            </h1>
                                        </div>
                                        <div class="col-span-12 sm:col-span-6">
                                            <label for="fullName" class="block mb-2 text-sm font-medium text-gray-900 ">Full Name</label>
                                            <Input placeholder="Enter Your Full Name"
                                                id="fullName"
                                                Icon={<FaUserDoctor className='text-green-500' />}
                                                value={values.fullName}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                isError={errors.fullName && touched.fullName}
                                            />
                                            {errors.fullName && touched.fullName && <p className='text-red-600 text-xs'>{errors.fullName}</p>}
                                        </div>
                                        <div class="col-span-12 sm:col-span-6">
                                            <label for="password" class="block mb-2 text-sm font-medium text-gray-900 ">Password <span className='text-green-700 text-[9px]'>(Please remember it for future refrence)</span> </label>
                                            <Input placeholder="Enter Password eg: Abcd@123"
                                                id="password"
                                                Icon={<RiLockPasswordFill className="text-green-500 h-4 w-4" />}
                                                value={values.password}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                isError={errors.password && touched.password}
                                            />
                                            {errors.password && touched.password && <p className='text-red-600 text-xs'>{errors.password}</p>}
                                        </div>

                                        <div class="col-span-12 sm:col-span-6">
                                            <label for="specialisationId" class="block mb-2 text-sm font-medium text-gray-900 ">Specialisation </label>
                                            <Select
                                                Icon={<MdMedicalInformation className='text-cyan-500 text-lg' />}
                                                id="specialisationId"
                                                value={values.specialisationId}
                                                onChange={handleChange}
                                                onBlur={handleBlur}>
                                                <option value="" selected>Select Specialisation...</option>
                                                {specialisationData.map((items, index) =>
                                                    <option value={items.id}>{items.name}({items.shortName})</option>
                                                )}
                                            </Select>
                                            {errors.specialisationId && touched.specialisationId && <p className='text-red-600 text-xs'>{errors.specialisationId}</p>}
                                        </div>

                                        <div class="col-span-12 sm:col-span-6">
                                            <label for="degree" class="block mb-2 text-sm font-medium text-gray-900 "> Degree</label>
                                            <Input placeholder="Enter Degree"
                                                id="degree"
                                                Icon={<FaUserGraduate className='text-blue-500 text-md' />}
                                                type="text"
                                                value={values.degree}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                isError={errors.degree && touched.degree}
                                            />
                                            {errors.degree && touched.degree && <p className='text-red-600 text-xs'>{errors.degree}</p>}

                                        </div>

                                        <div class="col-span-12 sm:col-span-6">
                                            <label for="experiance" class="block mb-2 text-sm font-medium text-gray-900 ">Experience</label>
                                            <Input placeholder="Enter Your Experience"
                                                id="experiance"
                                                Icon={<FaBriefcaseMedical className='text-yellow-500 text-md' />}
                                                type="text"
                                                value={values.experiance}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                isError={errors.experiance && touched.experiance}
                                            />
                                            {errors.experiance && touched.experiance && <p className='text-red-600 text-xs'>{errors.experiance}</p>}

                                        </div>
                                        <div class="col-span-12 sm:col-span-6">
                                            <label for="gender" class="block mb-2 text-sm font-medium text-gray-900 ">Gender</label>
                                            <Select
                                                Icon={<BsGenderAmbiguous className='text-orange-600 text-lg' />}
                                                id="gender"
                                                value={values.gender}
                                                onChange={handleChange}
                                                onBlur={handleBlur}>
                                                {GetEGender.EGender.map((items, index) =>
                                                    <option value={items.Id}>{items.Name}</option>
                                                )}
                                            </Select>
                                        </div>
                                        <div class="col-span-12 sm:col-span-6">
                                            <label class="block mb-2 text-sm font-medium text-gray-900 ">State</label>
                                            {!lodingStateCrud ?
                                                <Select
                                                    Icon={<FaMapLocationDot className='text-green-600 text-lg' />}
                                                    id="stateId"
                                                    value={values.stateId}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}>
                                                    <option value="" selected>Select state...</option>
                                                    {stateData.map((item) =>
                                                        <option value={item.id}>{item.name} ({item.shortName})</option>
                                                    )}
                                                </Select>
                                                : <Select disabled class="drop-down"
                                                    Icon={<FaMapLocationDot className='text-green-600 text-lg' />} >
                                                    <option >Loading states...</option>
                                                </Select>
                                            }
                                            {errors.stateId && touched.stateId && <p className='text-red-600 text-xs'>{errors.stateId}</p>}
                                        </div>

                                        <div class="col-span-12 sm:col-span-6">
                                            <label class="block mb-2 text-sm font-medium text-gray-900">City</label>
                                            {!lodingCityCrud ?
                                                <Select
                                                    id="cityId"
                                                    Icon={<FaLocationDot className='text-brand-600' />}
                                                    value={values.cityId}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}>
                                                    <option value="" selected>Select city...</option>
                                                    {cityData.map((item) =>
                                                        <option value={item.id}>{item.name} ({item.shortName})</option>
                                                    )}
                                                </Select>
                                                : <Select disabled class="drop-down"
                                                    Icon={<FaLocationDot className='text-brand-600' />} >
                                                    <option >Loading cities...</option>
                                                </Select>
                                            }
                                            {errors.cityId && touched.cityId && <p className='text-red-600 text-xs'>{errors.cityId}</p>}
                                        </div>

                                        <div class="col-span-12">
                                            <label for="address" class="block mb-2 text-sm font-medium text-gray-900 ">Address</label>
                                            <Input placeholder="Enter Your Address"
                                                id="address"
                                                Icon={<FaAddressCard className='text-brand-500 text-md' />}
                                                value={values.address}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                isError={errors.address && touched.address}
                                            />
                                            {errors.address && touched.address && <p className='text-red-600 text-xs'>{errors.address}</p>}

                                        </div>
                                    </div>
                                </div>
                                <div class="flex items-center p-6 space-x-3 rtl:space-x-reverse border-t border-gray-200 rounded-b">
                                    {!lodingCrud ?
                                        <button type="submit" className={!isValid ? "btn-blue-disabled" : "btn-blue"} disabled={!isValid}>Register</button>
                                        : <LodingButton text="Creating account.." />
                                    }
                                </div>
                            </form>

                        </Card>
                    </div>
                </div>
            }
            {level === 4 &&
                <UserRegisterCompleted />
            }
        </MasterPage >
    )
}